import { Box, Card, Text, Divider } from '@zillow/constellation';
import React from 'react';

import AuthorAvatar from './AuthorAvatar';
import type { AuthorCardProps } from './AuthorPage.types';
import Expertise from './Expertise';

/**
 * Card displaying the author's avatar, name, job title, and expertise.
 */
const AuthorCard: React.FC<AuthorCardProps> = ({ author }) => {
    return (
        <Box
            as={Card}
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                '&&&&': {
                    paddingTop: '$spacing.xl',
                    paddingBottom: '$spacing.xl',
                    paddingLeft: '$spacing.md',
                    paddingRight: '$spacing.md',
                },
            }}
            cardType="secondary"
        >
            <AuthorAvatar
                avatar={author.avatar}
                name={author.name}
                size="xxl"
            />
            <Box sx={{ display: 'none', '@media $lg': { display: 'block' } }}>
                <Text
                    as="h3"
                    fontType="h5"
                    fontColor="blue600"
                    marginBottom="xs"
                    textAlign="center"
                >
                    {author.name}
                </Text>
                <Text
                    as="p"
                    fontType="body"
                    fontColor="blue600"
                    marginBottom="lg"
                    textAlign="center"
                >
                    {author.jobTitle}
                </Text>
            </Box>
            {author.expertise && author.expertise.length > 0 && (
                <>
                    <Box as={Divider} length="fixed" marginBottom="lg" />
                    <Expertise expertise={author.expertise} />
                </>
            )}
        </Box>
    );
};

export default AuthorCard;
